import Vue from 'vue'
import bus from '../bus'
import toSnakeKeys from 'snakecase-keys'

const debug = true

const datatableCollection = ({ api, endpoint, fetchOn = [] }) => {
  fetchOn.push(endpoint + '.*')

  return new Vue({
    data () {
      return {
        all: [],
        length: 0,
        params: {},
        fetching: true,
        fetchedOnce: false,
      }
    },
    computed: {
      loading () {
        return this.fetching
      }
    },
    methods: {
      async fetch (params) {
        this.fetching = true
        this.fetchedOnce = true
        if (params) this.params = toSnakeKeys(params)
        if (debug) console.log('[vue-repository] ' + endpoint + '/datatableCollection fetching', this.params)
        try {
          const response = await api.get(endpoint + '/datatable', this.params)
          this.all = response.data
          this.length = response.meta.total
        } finally {
          this.fetching = false
        }
      },
      async _refresh() {
        if(this.fetchedOnce) {
          await this.fetch()
        }
      },
      destroy () {
        this.$destroy()
      }
    },
    created () {
      if (debug) console.log('[vue-repository] ' + endpoint + '/datatableCollection created')
      for (let event of fetchOn) {
        bus.on(event, this._refresh)
      }
    },
    destroyed () {
      if (debug) console.log('[vue-repository] ' + endpoint + '/datatableCollection destroyed')
      for (let event of fetchOn) {
        bus.off(event, this._refresh)
      }
    }
  })
}

export default ({ api, endpoint }) => {
  return {
    methods: {
      createDatatableCollection (options = {}) {
        return datatableCollection({ api, endpoint, ...options })
      }
    }
  }
}